// Comandos do agregado Tipo de Peça — item do catálogo têxtil (nome +
// Categoria + situação; sem preço, ADR-0006). A rota de Processos existe no
// modelo mas fica vazia na Fase 1. Dado puro; o executor só chama o domínio.

import type { Snapshot } from "../domain/snapshot.ts";
import {
  criarTipoPeca,
  definirAtivoTipoPeca,
  editarTipoPeca,
  type DadosTipoPeca,
} from "../domain/tipos-peca.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import { comoObjeto, exigirBooleano, exigirTexto, lista, texto } from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

// O comando referencia `DadosTipoPeca` do domínio, não uma cópia (ADR-0013).
// `processos` ausente = preserva a rota existente na edição.
export type ComandoTipoPeca =
  // `id` vem do cliente (ADR-0003): o executor é puro e a tela já sabe o id
  // do que criou, sem precisar caçá-lo no Snapshot depois.
  | { tipo: "criar"; id: string; dados: DadosTipoPeca }
  | { tipo: "editar"; id: string; dados: DadosTipoPeca }
  | { tipo: "definirAtivo"; id: string; ativo: boolean };

export function executarComandoTipoPeca(
  snapshot: Snapshot,
  cmd: ComandoTipoPeca,
  _ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "criar":
      return criarTipoPeca(snapshot, cmd.dados, cmd.id);
    case "editar":
      return editarTipoPeca(snapshot, cmd.id, cmd.dados);
    case "definirAtivo":
      return definirAtivoTipoPeca(snapshot, cmd.id, cmd.ativo);
    default:
      return assertNunca(cmd);
  }
}

function validarDados(valor: unknown): DadosTipoPeca {
  const o = comoObjeto(valor, "Dados do tipo de peça");
  const dados: DadosTipoPeca = {
    nome: texto(o.nome),
    categoriaId: texto(o.categoriaId),
  };
  // `processos` ausente OU null = "preserva a rota" na edição; só uma lista
  // de verdade substitui. O domínio apara e descarta vazios, então aqui os
  // itens passam como texto cru.
  if (o.processos != null) {
    dados.processos = lista(o.processos, "processos", (x) => texto(x));
  }
  return dados;
}

export function validarComandoTipoPeca(valor: unknown): ComandoTipoPeca {
  const c = comoObjeto(valor, "Comando de tipo de peça");
  switch (c.tipo) {
    case "criar":
      return {
        tipo: "criar",
        id: exigirTexto(c.id, "id"),
        dados: validarDados(c.dados),
      };
    case "editar":
      return {
        tipo: "editar",
        id: exigirTexto(c.id, "id"),
        dados: validarDados(c.dados),
      };
    case "definirAtivo":
      return {
        tipo: "definirAtivo",
        id: exigirTexto(c.id, "id"),
        ativo: exigirBooleano(c.ativo, "ativo"),
      };
    default:
      throw new Error(
        `Tipo de comando de tipo de peça desconhecido: ${String(c.tipo)}.`,
      );
  }
}
